<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">
                <div class="container">
                    <div class="mb-3">
                        <button class="btn btn-outline-secondary text-end" routerLink="/housing-hub">
                            ← Back
                        </button>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

                            <form [formGroup]="form" (ngSubmit)="onSubmit()">

                                <!-- ── Basic Information ──────────────────────────────────────── -->
                                <div class="card mb-4">
                                    <div class="card-header bg-warning text-dark fw-bold">
                                        Basic Information
                                    </div>
                                    <div class="card-body">

                                        <div class="row g-3">
                                            <div class="col-md-6">
                                                <label class="form-label fw-bold">Sell Status *</label>
                                                <select class="form-select" formControlName="sellStatus">
                                                    <option *ngFor="let o of sellStatusOptions" [value]="o">{{o}}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-label fw-bold">Property Type *</label>
                                                <select class="form-select" formControlName="propertyType">
                                                    <option *ngFor="let t of propertyTypeOptions" [value]="t">{{t}}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="row g-3 mt-2">
                                            <div class="col-md-6">
                                                <label class="form-label">Housing Type</label>
                                                <select class="form-select" formControlName="housingType">
                                                    <option *ngFor="let h of housingTypeOptions" [value]="h">{{h ||
                                                        'Select Housing
                                                        Type'}} </option>
                                                </select>
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-label fw-bold">Room/Property Title *</label>
                                                <input type="text" class="form-control" formControlName="roomTitle"
                                                    maxlength="80">
                                                <small class="text-muted">{{f.roomTitle.value?.length || 0}}/80</small>
                                            </div>
                                        </div>

                                        <div class="row g-3 mt-3">
                                            <div class="col-md-4">
                                                <label class="form-label">Bedrooms</label>
                                                <input type="number" min="0" class="form-control"
                                                    formControlName="bedRoomCount">
                                            </div>
                                            <div class="col-md-4">
                                                <label class="form-label">Bathrooms</label>
                                                <input type="number" min="0" class="form-control"
                                                    formControlName="washRoomCount">
                                            </div>
                                            <div class="col-md-4">
                                                <label class="form-label">Property Area</label>
                                                <div class="input-group">
                                                    <input type="number" min="0" class="form-control"
                                                        formControlName="propertyArea">
                                                    <select class="form-select" formControlName="propertyUnitArea">
                                                        <option>sq ft</option>
                                                        <option>sq m</option>
                                                        <option>acres</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row g-3 mt-3">
                                            <div class="col-md-6">
                                                <label class="form-label">Lot/Land Area</label>
                                                <div class="input-group">
                                                    <input type="number" min="0" class="form-control"
                                                        formControlName="lotLandArea">
                                                    <select class="form-select" formControlName="lotUnitArea">
                                                        <option>sq ft</option>
                                                        <option>sq m</option>
                                                        <option>acres</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-label">Status</label>
                                                <select class="form-select" formControlName="status">
                                                    <option *ngFor="let s of statusOptions" [value]="s">{{s}}</option>
                                                </select>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <!-- ── Pricing Information ────────────────────────────────────── -->
                                <div class="card mb-4">
                                    <div class="card-header bg-warning text-dark fw-bold">
                                        Pricing Information
                                    </div>
                                    <div class="card-body">
                                        <div class="row g-3">
                                            <div class="col-md-4">
                                                <label class="form-label">Price</label>
                                                <input type="text" class="form-control" formControlName="price">
                                            </div>
                                            <div class="col-md-4">
                                                <label class="form-label">Monthly Rent</label>
                                                <input type="number" min="0" class="form-control"
                                                    formControlName="monthlyRent">
                                            </div>
                                            <div class="col-md-4">
                                                <label class="form-label">Weekly Rent</label>
                                                <input type="number" min="0" class="form-control"
                                                    formControlName="weeklyRent">
                                            </div>
                                        </div>

                                        <div class="row g-3 mt-3">
                                            <div class="col-md-6">
                                                <label class="form-label">Rental Period</label>
                                                <input type="text" class="form-control" formControlName="rentalPeriod"
                                                    placeholder="e.g. 11 months">
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-label">Available Date</label>
                                                <input type="date" class="form-control" formControlName="availableDate">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- ── Location ───────────────────────────────────────────────── -->

                                <div class="card mb-4">
                                    <div class="card-header bg-warning text-dark fw-bold">
                                        Location
                                    </div>

                                    <div class="card-body" formGroupName="address">

                                        <label class="form-label fw-bold">Property Address *</label>
                                        <input type="text" class="form-control" ngx-google-places-autocomplete
                                            (onAddressChange)="AddressChange($event)" formControlName="googleAddress"
                                            placeholder="Start typing address...">

                                        <small class="text-danger"
                                            *ngIf="submitted && addr.hasError('addressRequired')">
                                            Please select a location from Google suggestions
                                        </small>

                                        <div class="row g-3 mt-3">
                                            <div class="col-md-6">
                                                <label class="form-label">Landmark</label>
                                                <input type="text" class="form-control" formControlName="landmark">
                                            </div>

                                            <div class="col-md-6">
                                                <label class="form-label">Contact Number (Address)</label>
                                                <input type="text" class="form-control" formControlName="contactNo">
                                            </div>
                                        </div>

                                        <div class="row g-3 mt-3">
                                            <div class="col-md-6">
                                                <label class="form-label">Alternate Contact Number</label>
                                                <input type="text" class="form-control" formControlName="alternateNo">
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <!-- ── Contact Information ────────────────────────────────────── -->
                                <div class="card mb-4">
                                    <div class="card-header bg-warning text-dark fw-bold">
                                        Contact Information
                                    </div>
                                    <div class="card-body">
                                        <div class="row g-3">
                                            <div class="col-md-6">
                                                <label class="form-label fw-bold">Contact Number *</label>
                                                <input type="tel" class="form-control" formControlName="contactNumber">
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-label">Email</label>
                                                <input type="email" class="form-control" formControlName="email">
                                            </div>
                                        </div>

                                        <div class="row g-3 mt-3">
                                            <div class="col-12">
                                                <label class="form-label">Name</label>
                                                <input type="text" class="form-control" formControlName="name">
                                            </div>
                                        </div>

                                        <div class="row g-3 mt-3">
                                            <div class="col-12">
                                                <label class="form-label">Contact Instructions</label>
                                                <textarea class="form-control" rows="2"
                                                    formControlName="contactInstruction"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- ── Additional Information ─────────────────────────────────── -->
                                <div class="card mb-4">
                                    <div class="card-header bg-warning text-dark fw-bold">
                                        Additional Information
                                    </div>
                                    <div class="card-body">

                                        <div class="row">

                                            <!-- Left column -->
                                            <div class="col-md-6">

                                                <h6 class="mb-3">Parking</h6>
                                                <div class="form-check" *ngFor="let opt of parkingOptions">
                                                    <input class="form-check-input larger-checkbox" type="checkbox"
                                                        [checked]="isChecked('parking', opt)"
                                                        (change)="toggleCheckbox('parking', opt, $event.target.checked)"
                                                        id="parking-{{opt}}">
                                                    <label class="form-check-label"
                                                        [for]="'parking-'+opt">{{opt}}</label>
                                                </div>

                                                <h6 class="mt-4 mb-3">Flooring</h6>
                                                <div class="form-check" *ngFor="let opt of flooringOptions">
                                                    <input class="form-check-input larger-checkbox" type="checkbox"
                                                        [checked]="isChecked('flooring', opt)"
                                                        (change)="toggleCheckbox('flooring', opt, $event.target.checked)"
                                                        id="flooring-{{opt}}">
                                                    <label class="form-check-label"
                                                        [for]="'flooring-'+opt">{{opt}}</label>
                                                </div>

                                                <h6 class="mt-4 mb-3">Smoking</h6>
                                                <div class="form-check" *ngFor="let opt of smokingOptions">
                                                    <input class="form-check-input larger-checkbox" type="checkbox"
                                                        [checked]="isChecked('smoking', opt)"
                                                        (change)="toggleCheckbox('smoking', opt, $event.target.checked)"
                                                        id="smoking-{{opt}}">
                                                    <label class="form-check-label"
                                                        [for]="'smoking-'+opt">{{opt}}</label>
                                                </div>

                                                <h6 class="mt-4 mb-3">EV Charging</h6>
                                                <div class="form-check" *ngFor="let opt of evChargingOptions">
                                                    <input class="form-check-input larger-checkbox" type="checkbox"
                                                        [checked]="isChecked('evCharging', opt)"
                                                        (change)="toggleCheckbox('evCharging', opt, $event.target.checked)"
                                                        id="ev-{{opt}}">
                                                    <label class="form-check-label" [for]="'ev-'+opt">{{opt}}</label>
                                                </div>

                                            </div>

                                            <!-- Right column -->
                                            <div class="col-md-6">

                                                <h6 class="mb-3">Laundry</h6>
                                                <div class="form-check" *ngFor="let opt of laundryOptions">
                                                    <input class="form-check-input larger-checkbox" type="checkbox"
                                                        [checked]="isChecked('laundry', opt)"
                                                        (change)="toggleCheckbox('laundry', opt, $event.target.checked)"
                                                        id="laundry-{{opt}}">
                                                    <label class="form-check-label"
                                                        [for]="'laundry-'+opt">{{opt}}</label>
                                                </div>

                                                <h6 class="mt-4 mb-3">Furnished</h6>
                                                <div class="form-check" *ngFor="let opt of furnishedOptions">
                                                    <input class="form-check-input larger-checkbox" type="checkbox"
                                                        [checked]="isChecked('furnished', opt)"
                                                        (change)="toggleCheckbox('furnished', opt, $event.target.checked)"
                                                        id="furnished-{{opt}}">
                                                    <label class="form-check-label"
                                                        [for]="'furnished-'+opt">{{opt}}</label>
                                                </div>

                                                <h6 class="mt-4 mb-3">Amenities</h6>
                                                <div class="form-check" *ngFor="let opt of amenitiesOptions">
                                                    <input class="form-check-input larger-checkbox" type="checkbox"
                                                        [checked]="isChecked('amenities', opt)"
                                                        (change)="toggleCheckbox('amenities', opt, $event.target.checked)"
                                                        id="amenity-{{opt}}">
                                                    <label class="form-check-label"
                                                        [for]="'amenity-'+opt">{{opt}}</label>
                                                </div>

                                                <h6 class="mt-4 mb-3">Wheelchair Accessible</h6>
                                                <div class="form-check" *ngFor="let opt of wheelchairOptions">
                                                    <input class="form-check-input larger-checkbox" type="checkbox"
                                                        [checked]="isChecked('wheelchairAccessible', opt)"
                                                        (change)="toggleCheckbox('wheelchairAccessible', opt, $event.target.checked)"
                                                        id="wheelchair-{{opt}}">
                                                    <label class="form-check-label"
                                                        [for]="'wheelchair-'+opt">{{opt}}</label>
                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                </div>
                                <!-- ── Pets ───────────────────────────────────────────────────── -->
                                <div class="card mb-4">
                                    <div class="card-header bg-warning text-dark fw-bold">
                                        Pets
                                    </div>
                                    <div class="card-body">

                                        <div class="input-group mb-3">
                                            <select class="form-select" [(ngModel)]="selectedPetType"
                                                [ngModelOptions]="{standalone: true}"
                                                style="border-top-right-radius: 0; border-bottom-right-radius: 0;">
                                                <option value="Select Pet Type" disabled>Select Pet Type</option>
                                                <option *ngFor="let pet of petsOptions" [value]="pet">{{pet}}</option>
                                            </select>
                                            <button class="btn btn-primary" type="button" (click)="addPet()">
                                                Add Pet
                                            </button>
                                        </div>

                                        <!-- Show added pets with remove button -->
                                        <div *ngIf="petsArray.length > 0" class="mt-3">
                                            <div class="d-flex flex-wrap gap-2">
                                                <span *ngFor="let petCtrl of petsArray.controls; let i = index"
                                                    class="badge bg-light text-dark border border-secondary d-flex align-items-center gap-2 px-3 py-2">
                                                    {{ petCtrl.value }}
                                                    <button type="button"
                                                        class="btn btn-sm btn-danger rounded-circle p-0"
                                                        style="width: 22px; height: 22px; font-size: 14px; line-height: 1;"
                                                        (click)="removePet(i)">
                                                        ×
                                                    </button>
                                                </span>
                                            </div>
                                        </div>

                                        <!-- Optional: message when no pets added -->
                                        <div *ngIf="petsArray.length === 0" class="text-muted mt-3 small">
                                            No pets selected yet
                                        </div>

                                    </div>
                                </div>

                                <!-- ── Other Information ──────────────────────────────────────── -->
                                <div class="card mb-4">
                                    <div class="card-header bg-warning text-dark fw-bold">
                                        Other Information
                                    </div>
                                    <div class="card-body">
                                        <div class="row g-3">
                                            <div class="col-md-6">
                                                <label class="form-label">Duration (days)</label>
                                                <input type="number" min="0" class="form-control"
                                                    formControlName="duration">
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-label">Open House Info</label>
                                                <input type="text" class="form-control" formControlName="openHouseInfo">
                                            </div>
                                        </div>

                                        <div class="mt-3">
                                            <label class="form-label">Description</label>
                                            <textarea class="form-control" rows="5" formControlName="description"
                                                maxlength="1200"></textarea>
                                            <small>{{f.description.value?.length || 0}}/1200</small>
                                        </div>

                                        <div class="mt-4">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="isAvailable" id="avail">
                                                <label class="form-check-label" for="avail">Available</label>
                                            </div>
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="isShowProfile" id="showProf">
                                                <label class="form-check-label" for="showProf">Show Profile</label>
                                            </div>
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="isFavorite" id="fav">
                                                <label class="form-check-label" for="fav">Favorite</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Photos + Submit -->
                                <div class="text-center mt-5">
                                    <button type="submit" class="btn btn-success btn-lg px-5">
                                        {{ isEditMode ? 'Update Property' : 'Create Property' }}
                                    </button>
                                </div>

                            </form>

                        </div>
                    </div>
                </div>
